import{config}from'config/index';import{newRequest}from'lib/v2/request.js';// Legacy request with the `v1` hard coded
var API_URL="".concat(config.apiUrl,"/v1");export default newRequest(API_URL);